import { HttpError } from '../../api/client';

const MESSAGES: Record<string, string> = {
  GUEST_ACCESS_VIP_EXCLUSIVE: 'Стол VIP нельзя открывать вместе со столами 5 и 6',
  GUEST_ACCESS_OVERLAP: 'На это время для выбранных столов уже есть гостевой доступ',
  GUEST_ACCESS_RESOURCE_BUSY: 'На некоторых столах уже есть мероприятие в это время',
  GUEST_ACCESS_HAS_EVENTS: 'Гости уже создали мероприятия вне нового времени или столов',
  GUEST_ACCESS_NOT_FOUND: 'Правило не найдено, возможно оно уже удалено',
  GUEST_ACCESS_REQUIRED: 'Этот стол сейчас не открыт для гостей на выбранное время',
  GUEST_ACCESS_LIMIT: 'В рамках одного гостевого доступа можно создать только одно мероприятие',
};

/** Human-readable message for a guest access API error, or `fallback` when the error is not a known code. */
export function guestAccessErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpError) {
    const known = error.code ? MESSAGES[error.code] : undefined;
    if (known) return known;
    if (error.payload?.message) return error.payload.message;
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
